import { SET_SCROLL } from "./constants";

const createAction = type => (fn = () => ({})) => (...args) => ({
  type,
  ...fn(...args)
});

export const setScroll = createAction(SET_SCROLL)(scroll => ({ scroll }));



// WEBPACK FOOTER //
// ./src/state/actions.js